export const errorToString = (
  error: unknown,
  _default = 'Nastala chyba',
): string => {
  let message = '';

  if ((error as { name: string })?.['name'] === 'HttpErrorResponse') {
    const httpError = error as { message: string; status: number; error: any };
    if (httpError.status === 0) {
      message = 'Server nie je dostupný';
    } else {
      message = 'Chyba servera: ' + httpError.status;
    }
  }

  if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  } else if (typeof error === 'object' && error !== null) {
    if ('message' in error && typeof error.message === 'string') {
      message = error.message;
    } else if ('error' in error && typeof error.error === 'string') {
      message = error.error;
    }
  }

  return message || _default;
};
